import React, { useEffect, useState, } from "react";
import Noti from "../../../util/noti";
import { NormalSelect } from "./NormalSelect";
import "./issueFormCss.css";
import { useForm } from "react-hook-form";
import { Container, Row, Col } from "react-bootstrap";
import Axios from "axios";
import Icon from "@material-ui/core/Icon";
import { Must } from "../SiteCreationComp/Fields";
import Loader from "../../general/Loader";
import { useUser } from "../../../util/user";
import { checkIfObject, checkIfObjectHasKeys, checkIfArray, } from "../../../util/checking";
import { dateTimeFormat, dateTimeForm, changeToNull, dateTimeFormatCompare, } from "../../../util/formatter";
import GYAxios from "../../../util/GYAxios";
import DatePicker from "react-datepicker";
import moment from "moment-timezone";
import { localTimeToPickerTime, pickerTimeTolocalTime } from "../../../util/momentTimezone";

export const IssueForm = (props) => {
	const user = useUser().preferred_username;

	const { register, handleSubmit, errors, setValue, watch } = useForm();
	const [loadForm, setLoadForm] = useState(false);

	const [isSiteID, setIsSiteID] = useState(false);
	const [isIssueID, setIsIssueID] = useState(false);
	const [isActionID, setIsActionID] = useState(false);
	const [propsID, setPropsID] = useState(null);

	const [data, setData] = useState({});
	const [alarmList, setAlarmList] = useState([]);
	const [issueCatList, setIssueCatList] = useState([]);
	const [authorList, setAuthorList] = useState([]);
	const [unavailabilityList, setUnavailabilityList] = useState([]);
	const [unCatList, setUnCatList] = useState([]);
	const [unSubCatList, setUnSubCatList] = useState([]);
	const [issueDescList, setIssueDescList] = useState([]);
	const [actionDescList, setActionDescList] = useState([]);

	const [issueDescSelected, setIssueDescSelected] = useState({});

	const alarmDevice = watch("alarmDevice");
	const problem = watch("problem");
	const issueDate = watch("issueDate");
	const gyIssueDesc = watch("gyIssueDesc");
	const clIssueDesc = watch("clIssueDesc");
	const comment = watch("comment");
	const author = watch("author");
	const unavailability = watch("unavailability");
	const unCat = watch("unCat");
	const unSubCat = watch("unSubCat");
	const resolved = watch("resolved");

	const actionDate = watch("actionDate", null);
	const gyActionDesc = watch("gyActionDesc", null);
	const clActionDesc = watch("clActionDesc", null);

	const [issueDescShow, setIssueDescShow] = useState(false);
	const [actionDescShow, setActionDescShow] = useState(true);
	const [loading, setLoading] = useState(false);
	const [issueReadOnly, setIssueReadOnly] = useState(false);

	const [editGyIssueDesc, setEditGyIssueDesc] = useState(true);
	const [editClIssueDesc, setEditClIssueDesc] = useState(true);
	const [editGyActionDesc, setEditGyActionDesc] = useState(true);
	const [editClActionDesc, setEditClActionDesc] = useState(true);

	const [startIssueDate, setStartIssueDate] = useState(null);
	const [startActionDate, setStartActionDate] = useState(null);
	const todayToDate = moment().toDate();

	function notifyError() {
		Noti.create({
			type: "e",
			msg: "Something is wrong. Please contact IT department!",
		});
	}

	function reloadReport() {
		props.reloadReport();
		props.closeForm();
	}

	function resetIssueDescFields() {
		onChangeForm("gyIssueDesc", null);
		onChangeForm("clIssueDesc", null);
		onChangeForm("unavailability", null);
		onChangeForm("unCat", null);
		onChangeForm("unSubCat", null);
		onChangeForm("author", null);
		onChangeForm("actionDate", null);
		setStartActionDate(null);
		onChangeForm("gyActionDesc", null);
		onChangeForm("clActionDesc", null);
		onChangeForm("comment", null);
		onChangeForm("resolved", false);
	}

	function onChangeAlarm(alarm) {
		if (checkIfObject(alarm)) {
			onChangeForm("alarmDevice", alarm);
			onChangeForm("problem", null);
			getIssueCatList(alarm.value);

			if (
				!(
					changeToNull(data.gy_desc) !== null &&
					changeToNull(data.cl_desc) !== null &&
					changeToNull(data.alarm_id) === null
				)
			) {
				setIssueDescShow(false);
				setIssueDescList([]);
			}
		} else {
			notifyError();
			return;
		}
	}

	function onChangeUn(un) {
		if (checkIfObject(un)) {
			onChangeForm("unavailability", un);
			onChangeForm("unCat", null);
			onChangeForm("unSubCat", null);
			getUnCatList(un.value);
			
			if (!changeToNull(data.un_id) === null) {
				setUnSubCatList([]);
				setUnCatList([]);
			}
		} else {
			notifyError();
			return;
		}
	}

	function onChangeUnCat(unCat) {
		if (checkIfObject(unCat)) {
			onChangeForm("unSubCat", null);
			setUnSubCatList([]);
			onChangeForm("unCat", unCat);
			getUnSubCatList(unCat.value);
		} else {
			notifyError();
			return;
		}
	}

	function onChangeIssueCat(prob) {
		if (checkIfObject(prob)) {
			onChangeForm("problem", prob);
			getIssueDescList(prob.value);

			if (!(data.alarm_id === null && data.prob_id === null)) {
				if (!(data.alarm_id !== undefined && data.alarm_id !== null && alarmDevice === undefined)) {
					setLoading(true);
					resetIssueDescFields();
				}
			}

			setTimeout(() => {
				setIssueDescShow(true);
				setLoading(false);
			}, 1000);
		} else {
			notifyError();
			return;
		}
	}

	function onChangeIssueDesc(desc) {
		if (checkIfObject(desc)) {
			onChangeForm("gyIssueDesc", desc.gy_desc);
			onChangeForm("clIssueDesc", desc.cl_desc);
			onChangeForm("gyActionDesc", "");
			onChangeForm("clActionDesc", "");

			setIssueDescSelected(desc);
			getActionDescList(desc.value);
		} else {
			notifyError();
			return;
		}
	}

	function onChangeActionDesc(desc) {
		if (checkIfObject(desc)) {
			onChangeForm("gyActionDesc", desc.gy_desc);
			onChangeForm("clActionDesc", desc.cl_desc);
		} else {
			notifyError();
			return;
		}
	}

	function getIssueCatList(alarm_id) {
		GYAxios
			.get(`/select/closed_problem/${alarm_id}`)
			.then((res) => {
				if (res.data.error !== undefined) {
					console.log(res.data);
					Noti.create({
						type: "e",
						msg: "No problem is detected.",
					});
					return;
				} else {
					setIssueCatList(res.data);
					if (res.data.length === 1) {
						onChangeIssueCat(res.data[0])
					}
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	function getUnCatList(un_id) {
		GYAxios.get(`/select/un_category?un_id=${un_id}`)
			.then((res) => {
				if (res.data.error !== undefined) {
					console.log(res.data);
					Noti.create({
						type: "e",
						msg: "No unavailability category is detected.",
					});
					return;
				} else {
					setUnCatList(res.data);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	function getUnSubCatList(un_cat_id, un_id = null) {
		const _un_id = un_id === null ? unavailability : un_id;
		GYAxios.get(`/select/un_sub_category?un_cat_id=${un_cat_id}&un_id=${_un_id}`)
			.then((res) => {
				if (res.data.error !== undefined) {
					console.log(res.data);
					Noti.create({
						type: "e",
						msg: "No unavailability sub-category is detected.",
					});
					return;
				} else {
					setUnSubCatList(res.data);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	function getIssueDescList(prob_id) {
		GYAxios
			.get(`/select/closed_issue_desc/${prob_id}`)
			.then((res) => {
				if (res.data.error !== undefined) {
					console.log(res.data);
					Noti.create({
						type: "e",
						msg: "No issue description is detected.",
					});
					return;
				} else {
					setIssueDescList(res.data);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	function getActionDescList(issue_desc_id) {
		GYAxios
			.get(`/select/closed_action_desc/${issue_desc_id}`)
			.then((res) => {
				if (res.data.error !== undefined) {
					console.log(res.data);
					Noti.create({
						type: "e",
						msg: "No Action description is detected.",
					});
					return;
				} else {
					setActionDescList(res.data);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	function onChangeForm(name, newVal) {
		if (checkIfObject(newVal)) setValue(name, newVal.value);
		else setValue(name, newVal);
	}

	function notEmpty(val) {
		if (val !== undefined && val !== "" && val !== null) return true;
		return false;
	}

	function actionDateIsAfterOrEqual(iD, aD) {
		if (dateTimeFormat(iD) <= dateTimeFormat(aD)) return true;
		else return false;
	}

	/**
	 * Processing and return a valid issue
	 * @param {Object} sI submitted issue
	 */
	const processSubmittedIssue = (sI) => {
		if (
			notEmpty(sI.alarmDevice) &&
			notEmpty(sI.problem) &&
			notEmpty(sI.issueDate) &&
			notEmpty(sI.clIssueDesc) &&
			notEmpty(sI.gyIssueDesc)
		) {
			let temp_issue = {
				last_updated_by: user,
				last_updated_at: dateTimeFormat(),
			};

			temp_issue.alarm_id = sI.alarmDevice; // mandatory
			temp_issue.prob_id = sI.problem; // mandatory
			temp_issue.gy_desc = sI.gyIssueDesc; // mandatory
			temp_issue.cl_desc = sI.clIssueDesc; // mandatory
			temp_issue.issue_date = dateTimeFormat(sI.issueDate); // mandatory

			if (notEmpty(sI.resolved) && sI.resolved && !notEmpty(sI.unavailability)) {
				window.alert("Cannot resolve an issue without unavailability");
				return;
			}

			// if (sI.resolved && data.status === 1) {
			// 	window.alert(
			// 		"Rejected! You have to re-open (unsolve) issue before making modification."
			// 	);
			// 	return;
			// }

			const tempStatus = changeToNull(sI.resolved); // optional
			if (!tempStatus) temp_issue.resolved_date = null;

			return (temp_issue = {
				...temp_issue,
				un_id: changeToNull(sI.unavailability),
				un_cat_id: changeToNull(sI.unCat),
				un_sub_cat_id: changeToNull(sI.unSubCat),
				auth_id: changeToNull(sI.author),
				comment: changeToNull(sI.comment),
				status: tempStatus ? 1 : 0,
			});
		} else {
			window.alert("Missing mandatory fields.");
			return null;
		}
	};

	/**
	 * Processing and return a valid action
	 * @param {Object} sA submitted action
	 * @param {Object} pI processed issue
	 */
	const processSubmittedAction = (sA, pI) => {
		if (
			notEmpty(sA.actionDate) ||
			notEmpty(sA.gyActionDesc) ||
			notEmpty(sA.clActionDesc)
		) {
			if (!notEmpty(sA.actionDate) || !notEmpty(sA.gyActionDesc) || !notEmpty(sA.clActionDesc)) {
				window.alert("Fulfill all Action Fields or leave them blank");
				return null;
			} else {
				if (!actionDateIsAfterOrEqual(pI.issue_date, sA.actionDate)) {
					window.alert("Action Date should be after Issue Date");
					return null;
				}

				return {
					last_updated_by: user,
					last_updated_at: dateTimeFormat(),
					gy_desc: sA.gyActionDesc,
					cl_desc: sA.clActionDesc,
					action_date: dateTimeFormat(sA.actionDate),
				};
			}
		} else if (
			data.action_id !== undefined &&
			!notEmpty(sA.actionDate) &&
			!notEmpty(sA.gyActionDesc) &&
			!notEmpty(sA.clActionDesc)
		) {
			return { delete_action_id: data.action_id };
		} else return {};
	};

	function checkLatestDate(assumedLatest, inputDate) {
		if (
			dateTimeFormatCompare(assumedLatest) < dateTimeFormatCompare(inputDate)
		) {
			return dateTimeFormat(inputDate);
		} else {
			return dateTimeFormat(assumedLatest);
		}
	}

	const insertNewIssue = async (input) => {
		const temp_issue = {
			...input,
			created_by: user,
			created_at: dateTimeFormat(),
			site_id: propsID,
		};

		const issue_param = Object.fromEntries(
			Object.entries(temp_issue).filter(([_, v]) => v !== null)
		);

		return await GYAxios.post("/issue/", issue_param).then((res) => {
			if (res.data.error !== undefined || res.data?.insertId === 0) {
				console.log(res.data);
				Noti.create({
					type: "e",
					msg: `Inserting new issue is failed. Please try again or contact IT Department.`,
				});
				return null;
			} else {
				Noti.create({
					type: "s",
					msg: `New issue is inserted successfully.`,
				});
				return res.data.insertId;
			}
		});
	};

	const insertNewAction = async (input, issueID) => {
		const temp_action = {
			...input,
			created_by: user,
			created_at: dateTimeFormat(),
			issue_id: issueID,
		};

		const action_param = Object.fromEntries(
			Object.entries(temp_action).filter(([_, v]) => v !== null)
		);

		return await GYAxios.post("/actions/", action_param).then((res) => {
			if (res.data.error !== undefined || res.data?.insertId === 0) {
				console.log(res.data);
				Noti.create({
					type: "e",
					msg: `Inserting new action is failed. Please try again or contact IT Department.`,
				});
				return null;
			} else {
				Noti.create({
					type: "s",
					msg: `New action is inserted successfully.`,
				});
				return res.data.insertId;
			}
		});
	};

	const updateIssue = async (input) => {
		return await GYAxios.put(`/issue/${propsID}`, input).then((res) => {
			if (res.data.error !== undefined || res.data?.affectedRows === 0) {
				console.log(res.data);
				Noti.create({
					type: "e",
					msg: `Updating issue is failed. Please try again or contact IT Department.`,
				});
				return null;
			} else {
				Noti.create({
					type: "s",
					msg: `Issue is updated successfully.`,
				});
				return res.data.affectedRows;
			}
		});
	};

	const updateAction = async (input) => {
		return await GYAxios.put(`/actions/${data.action_id}`, input).then((res) => {
			if (res.data.error !== undefined || res.data?.affectedRows === 0) {
				console.log(res.data);
				Noti.create({
					type: "e",
					msg: `Updating action is failed. Please try again or contact IT Department.`,
				});
				return null;
			} else {
				Noti.create({
					type: "s",
					msg: `Action is updated successfully.`,
				});
				return res.data.affectedRows;
			}
		});
	};

	const deleteAction = async () => {
		return await GYAxios.delete(`/actions/${data.action_id}`).then((res) => {
			if (res.data.error !== undefined || res.data?.affectedRows === 0) {
				console.log(res.data);
				Noti.create({
					type: "e",
					msg: `Deleting action is failed. Please try again or contact IT Department.`,
				});
				return null;
			} else {
				Noti.create({
					type: "s",
					msg: `Action is deleted successfully.`,
				});
				return res.data.affectedRows;
			}
		});
	};

	const updateResolvedDate = async (issue_id, suggestedDate) => {
		const rD = suggestedDate === null ? null : dateTimeFormat(suggestedDate);
		const st = suggestedDate === null ? 0 : 1;

		return await GYAxios
			.put(`/issue/${issue_id}`, {
				resolved_date: rD,
				status: st,
				last_updated_by: user,
				last_updated_at: dateTimeFormat(),
			})
			.then((res) => {
				if (res.data.error !== undefined || res.data?.affectedRows === 0) {
					console.log(res.data);
					Noti.create({
						type: "e",
						msg: `Updating resolved date is failed. Please try again or contact IT Department.`,
					});
					return null;
				} else {
					reloadReport();
					if (suggestedDate !== null) {
						Noti.create({
							type: "s",
							msg: `Issue is set to resolved.`,
						});
					} else {
						Noti.create({
							type: "s",
							msg: `Issue is set to unresolved.`,
						});
					}
					return res.data.affectedRows;
				}
			});
	};

	function onSubmit(submittedData) {
		// if (editGyIssueDesc || editClIssueDesc || editGyActionDesc || editClActionDesc) {
		// 	window.alert("Please close all text fields when submitting.");
		// 	return;
		// }

		if (propsID === null || checkIfObjectHasKeys(errors)) {
			Noti.create({
				type: "e",
				msg: `Some thing is wrong.`,
			});
			return;
		}

		const processedIssue = processSubmittedIssue(submittedData);
		let processedAction = null;

		if (checkIfObjectHasKeys(processedIssue))
			processedAction = processSubmittedAction(submittedData, processedIssue);

		if (processedIssue === null || processedAction === null) {
			return;
		}

		// full form
		if (isSiteID || (isIssueID && actionDescShow)) {
			if (isSiteID) {
				insertNewIssue(processedIssue).then(function (issueInsertedID) {
					if (issueInsertedID !== null) {
						if (
							checkIfObjectHasKeys(processedAction) &&
							processedAction.delete_action_id === undefined
						) {
							insertNewAction(processedAction, issueInsertedID).then(function (
								actionInsertID
							) {
								if (actionInsertID !== null) {
									if (processedIssue.status === 1) {
										updateResolvedDate(
											issueInsertedID,
											processedAction.action_date
										);
									} else {
										reloadReport();
									}
								}
							});
						} else {
							if (processedIssue.status === 1) {
								updateResolvedDate(issueInsertedID, processedIssue.issue_date);
							} else {
								reloadReport();
							}
						}
					}
				});
			}

			if (isIssueID && actionDescShow) {
				if (checkIfObjectHasKeys(processedAction)) {
					if (processedAction.delete_action_id === undefined) {
						if (data.action_id !== undefined && data.action_id !== null) {
							updateIssue(processedIssue).then(function (updateIssueStatus) {
								if (updateIssueStatus !== null) {
									updateAction(processedAction).then(function (
										updateActionStatus
									) {
										if (updateActionStatus !== null) {
											if (processedIssue.status === 1) {
												updateResolvedDate(propsID, processedAction.action_date);
											} else {
												reloadReport();
											}
										}
									});
								}
							});
						} else {
							updateIssue(processedIssue).then(function (updateIssueStatus) {
								if (updateIssueStatus !== null) {
									insertNewAction(processedAction, propsID).then(function (
										actionInsertID
									) {
										if (actionInsertID !== null) {
											if (processedIssue.status === 1) {
												updateResolvedDate(propsID, processedAction.action_date);
											} else {
												reloadReport();
											}
										}
									});
								}
							});
						}
					} else {
						updateIssue(processedIssue).then(function (updateIssueStatus) {
							if (updateIssueStatus !== null) {
								deleteAction().then(function (deleteActionStatus) {
									if (deleteActionStatus !== null) {
										if (processedIssue.status === 1) {
											updateResolvedDate(propsID, processedIssue.issue_date);
										} else {
											reloadReport();
										}
									}
								});
							}
						});
					}
				} else {
					updateIssue(processedIssue).then(function (updateIssueStatus) {
						if (updateIssueStatus !== null) {
							if (processedIssue.status === 1) {
								updateResolvedDate(propsID, processedIssue.issue_date);
							} else {
								reloadReport();
							}
						}
					});
				}
			}
		}

		if (isIssueID && !actionDescShow) {
			updateIssue(processedIssue).then(function (updateIssueStatus) {
				if (updateIssueStatus !== null) {
					if (processedIssue.status === 1) {
						let latestAction = data.actions[0].action_date;
						data.actions.forEach((v) => {
							latestAction = checkLatestDate(latestAction, v.action_date);
						});

						updateResolvedDate(propsID, latestAction);
					} else {
						reloadReport();
					}
				}
			});
		}

		if (isActionID && propsID.actionID === null) {
			if (checkIfObjectHasKeys(processedAction)) {
				if (processedAction.delete_action_id !== undefined) {
					Noti.create({
						type: "w",
						msg: `Press Cancel when you dont want to add any action`,
					});
					return;
				} else {
					insertNewAction(processedAction, propsID.issueID).then(function (
						actionInsertID
					) {
						if (actionInsertID !== null) {
							if (data.status !== processedIssue.status) {
								if (processedIssue.status === 1) {
									let latestAction = processedAction.action_date;
									data.actions.forEach((v) => {
										latestAction = checkLatestDate(latestAction, v.action_date);
									});

									updateResolvedDate(propsID.issueID, latestAction);
								} else {
									updateResolvedDate(propsID.issueID, null);
								}
							} else reloadReport();
						}
					});
				}
			}
		}

		if (isActionID && propsID.actionID !== null) {
			if (checkIfObjectHasKeys(processedAction)) {
				if (processedAction.delete_action_id !== undefined) {
					Noti.create({
						type: "w",
						msg: `Press Cancel when you dont want to add any action`,
					});
					return;
				} else {
					updateAction(processedAction).then(function (updateActionStatus) {
						if (updateActionStatus !== null) {
							if (data.status !== processedIssue.status) {
								if (processedIssue.status === 1) {
									let latestAction = processedAction.action_date;
									data.actions.forEach((v) => {
										latestAction = checkLatestDate(latestAction, v.action_date);
									});

									updateResolvedDate(propsID.issueID, latestAction);
								} else {
									updateResolvedDate(propsID.issueID, null);
								}
							} else reloadReport();
						}
					});
				}
			}
		}
	}

	useEffect(() => {
		register({ name: "alarmDevice" });
		register({ name: "problem" });
		register({ name: "issueDate" });
		register({ name: "gyIssueDesc" });
		register({ name: "clIssueDesc" });
		register({ name: "comment" });
		register({ name: "author" });
		register({ name: "unavailability" });
		register({ name: "unCat" });
		register({ name: "unSubCat" });
		register({ name: "actionDate" });
		register({ name: "gyActionDesc" });
		register({ name: "clActionDesc" });
		register({ name: "resolved" });
	}, [register]);

	useEffect(() => {
		if (startIssueDate !== null) onChangeForm("issueDate", dateTimeFormat(startIssueDate));
		else onChangeForm("issueDate", null);
	}, [startIssueDate]);

	useEffect(() => {
		if (startActionDate !== null) onChangeForm("actionDate", dateTimeFormat(startActionDate));
		else onChangeForm("actionDate", null);
	}, [startActionDate]);

	useEffect(() => {
		const getSomeLists = (req, name, method) => {
			GYAxios
				.get(`/select/${req}`)
				.then((res) => {
					if (res.data.error !== undefined || user === "" || user === null) {
						console.log(res.data);
						Noti.create({
							type: "e",
							msg: `No ${name} is detected.`,
						});
						return;
					} else {
						method(res.data);
					}
				})
				.catch((err) => {
					console.log(err);
				});
		};

		const fetchIssue = (id, action_id) => {
			Axios
				.all([GYAxios.get(`/issue/${id}`), GYAxios.get(`/actions/issue/${id}`)])
				.then(
					Axios.spread((...ress) => {
						if (checkIfArray(ress)) {
							if (ress.length !== 2) {
								console.log(ress);
								Noti.create({
									type: "e",
									msg: "Something is wrong with getting details of selected issue.",
								});
								return;
							}

							if (!checkIfObjectHasKeys(ress[0]?.data)) {
								console.log(ress[0]);
								Noti.create({
									type: "e",
									msg: "Something is wrong with getting details of selected issue.",
								});
								return;
							}

							if (!checkIfArray(ress[1]?.data)) {
								console.log(ress[1]);
								Noti.create({
									type: "e",
									msg: "Something is wrong with getting actions of selected issue.",
								});
								return;
							}

							const processedData = {
								...ress[0].data,
								action_id:
									action_id !== undefined && action_id !== null
										? action_id
										: ress[1].data[0]?.id,
								actions: ress[1].data,
							};

							setData(processedData);
						} else {
							console.log(ress);
							Noti.create({
								type: "e",
								msg: "Something is wrong with getting details of selected issue.",
							});
							return;
						}
					})
				);
		};

		if (checkIfObjectHasKeys(props.id)) {
			if (props.id.siteID !== undefined) {
				setIsSiteID(true);
				setPropsID(props.id.siteID);
				setLoadForm(true);
			} else if (props.id.issueID !== undefined) {
				setIsIssueID(true);
				setPropsID(props.id.issueID);
				fetchIssue(props.id.issueID);
			} else if (props.id.actionID !== undefined) {
				setIsActionID(true);
				setPropsID(props.id.actionID);
				fetchIssue(props.id.actionID.issueID, props.id.actionID.actionID);
			} else {
				setLoadForm(false);
				setPropsID(null);
				notifyError();
				return;
			}

			getSomeLists("closed_alarm_issue", "alarm device", setAlarmList);
			getSomeLists("closed_level", "authorisation", setAuthorList);
			getSomeLists("closed_unavailability", "unavailability", setUnavailabilityList);
		} else {
			setLoadForm(false);
			setPropsID(null);
			notifyError();
			return;
		}
	}, [props.id]);

	useEffect(() => {
		if (checkIfObjectHasKeys(issueDescSelected) && !editGyIssueDesc) {
			if (issueDescSelected?.label !== gyIssueDesc) {
				setActionDescList([]);
				onChangeForm("gyActionDesc", "");
				onChangeForm("clActionDesc", "");
			} else {
				getActionDescList(issueDescSelected.value);
			}
		}
	}, [editGyIssueDesc]);

	useEffect(() => {
		const setIssueFromFetchedData = (temp) => {
			onChangeForm("issueDate", dateTimeForm(temp.issue_date));
			setStartIssueDate(moment(temp.issue_date).toDate());
			onChangeForm("alarmDevice", temp.alarm_id);
			onChangeForm("problem", temp.prob_id);
			onChangeForm("gyIssueDesc", temp.gy_desc);
			onChangeForm("clIssueDesc", temp.cl_desc);
			onChangeForm("comment", temp.comment);
			onChangeForm("author", temp.auth_id);
			onChangeForm("unavailability", temp.un_id);
			onChangeForm("unCat", temp.un_cat_id);
			onChangeForm("unSubCat", temp.un_sub_cat_id);
			onChangeForm("resolved", temp.status === 1 ? true : false);

			getIssueCatList(temp.alarm_id);
			getIssueDescList(temp.prob_id);
			
			getUnCatList(temp.un_id);
			getUnSubCatList(temp.un_cat_id, temp.un_id);

			setIssueDescShow(true);
			setLoadForm(true);
		};

		const setActionFromFetchedData = (temp) => {
			onChangeForm("actionDate", dateTimeForm(temp.action_date));
			setStartActionDate(moment(temp.action_date).toDate());
			onChangeForm("gyActionDesc", temp.gy_action);
			onChangeForm("clActionDesc", temp.cl_action);
		};

		if (checkIfObjectHasKeys(data) && !isSiteID) {
			setIssueFromFetchedData(data);

			if (isIssueID && checkIfArray(data.actions)) {
				if (data.actions.length > 1) setActionDescShow(false);
				if (data.actions.length === 1)
					setActionFromFetchedData(data.actions[0]);
			}

			if (isActionID) {
				// adding or editting action
				if (propsID.actionID !== null) {
					const actionEdit = data.actions.filter(
						(v) => v.id === propsID.actionID
					);
					setActionFromFetchedData(actionEdit[0]);
				}
				setIssueReadOnly(true);
			}
		}
	}, [data]);

	useEffect(() => {
		if (issueDescList.length > 0 && (isActionID || isIssueID)) {
			const issueDescVal = issueDescList.filter(
				(v) => v.label === data.gy_desc
			);

			if (issueDescVal.length > 0) {
				getActionDescList(issueDescVal[0].value);
			}
		}
	}, [issueDescList]);

	return (
		<>
			<Row style={{ marginBottom: "10px", textAligh: "right" }}>
				<Col sm={1}></Col>
				<Col sm={10} style={{ textAlign: "center" }}>
					<h4>ISSUE REPORT</h4>
				</Col>
				<Col sm={1} style={{ textAlign: "right" }}>
					<span style={{ cursor: "pointer" }} onClick={() => props.closeForm()}>
						X
					</span>
				</Col>
			</Row>
			{loadForm && (
				<Container fluid stye={{ fontSize: "1.25em" }} id={"issueForm"}>
					<form onSubmit={handleSubmit(onSubmit)}>
						<Row>
							<Col sm={3}>
								Alarm Device List: <Must />
							</Col>
							<Col sm={9}>
								<NormalSelect
									onChange={onChangeAlarm}
									list={alarmList}
									text={"Select an alarm device"}
									defaultVal={alarmDevice ? { value: alarmDevice } : null}
									isDisable={issueReadOnly}
								/>
							</Col>
						</Row>

						<Row>
							<Col sm={3}>
								Issue Category List: <Must />
							</Col>
							<Col sm={9}>
								<NormalSelect
									onChange={onChangeIssueCat}
									list={issueCatList}
									text={"Select an issue category"}
									defaultVal={problem ? { value: problem } : null}
									isDisable={issueReadOnly}
								/>
							</Col>
						</Row>
						<Row className="normalInput">
							<Col sm={3}>
								Issue Date: <Must />
							</Col>
							<Col sm={9}>
								<DatePicker
									placeholderText="Year/Month/Day Hour:Minute 12-hour clock format"
									selected={startIssueDate && localTimeToPickerTime(startIssueDate)}
									onChange={(date) => setStartIssueDate(pickerTimeTolocalTime(date))}
									showTimeSelect
									timeFormat="p"
									timeIntervals={10}
									dateFormat="yyyy/MM/dd h:mm aa"
									disabled={issueReadOnly}
								/>
							</Col>
						</Row>
						{issueDescShow ? (
							<div id={"issue_desc"}>
								<Row>
									<Col sm={3}>Issue Description:</Col>
									<Col sm={9}>
										{issueDescList.length > 0 && (
											<NormalSelect
												onChange={onChangeIssueDesc}
												list={issueDescList}
												text={"Select an issue description or Input one"}
												defaultVal={gyIssueDesc ? { label: gyIssueDesc } : null}
												isDisable={issueReadOnly}
											/>
										)}
									</Col>
								</Row>

								<Row className="normalInput">
									<Col sm={3} className="indentLTR">
										Internal Description: <Must />
									</Col>
									<Col sm={9}>
										<input
											type="text"
											ref={register}
											value={gyIssueDesc || ""}
											onChange={(e) =>
												onChangeForm("gyIssueDesc", e.target.value)
											}
											readOnly={!editGyIssueDesc}
											name="gyIssueDesc"
											style={
												!editGyIssueDesc
													? { backgroundColor: "#E8E8E8" }
													: { backgroundColor: "#fff" }
											}
										/>
									</Col>
									{/* {!editGyIssueDesc && !issueReadOnly && (
										<Col sm={1}>
											<Icon onClick={(e) => setEditGyIssueDesc(true)}>
												edit
											</Icon>
										</Col>
									)} */}
									{/* {editGyIssueDesc && (
										<Col sm={1}>
											<Icon onClick={(e) => setEditGyIssueDesc(false)}>
												check
											</Icon>
										</Col>
									)} */}
								</Row>

								<Row className="normalInput">
									<Col sm={3} className="indentLTR">
										Client Description: <Must />
									</Col>
									<Col sm={9}>
										<input
											type="text"
											ref={register}
											value={clIssueDesc || ""}
											onChange={(e) =>
												onChangeForm("clIssueDesc", e.target.value)
											}
											readOnly={!editClIssueDesc}
											name="clIssueDesc"
											style={
												!editClIssueDesc
													? { backgroundColor: "#E8E8E8" }
													: { backgroundColor: "#fff" }
											}
										/>
									</Col>
									{/* {!editClIssueDesc && !issueReadOnly && (
										<Col sm={1}>
											<Icon onClick={(e) => setEditClIssueDesc(true)}>
												edit
											</Icon>
										</Col>
									)}
									{editClIssueDesc && (
										<Col sm={1}>
											<Icon onClick={(e) => setEditClIssueDesc(false)}>
												check
											</Icon>
										</Col>
									)} */}
								</Row>

								<Row>
									<Col md={4}>
										<Row id={"unavailability"}>
											<p>Unavailability</p>
											<Col sm={9}>
												<NormalSelect
													onChange={onChangeUn}
													list={unavailabilityList}
													text={"Select an unavailability"}
													defaultVal={
														unavailability
															? { value: unavailability }
															: unavailability
													}
													isDisable={issueReadOnly}
												/>
											</Col>
										</Row>
									</Col>

									<Col md={4}>
										<Row>
											<p>Category</p>
											<Col sm={9}>
												<NormalSelect
													onChange={onChangeUnCat}
													list={unCatList}
													text={"Select unavailability category"}
													defaultVal={
														unCat
															? { value: unCat }
															: unCat
													}
													isDisable={issueReadOnly}
												/>
											</Col>
										</Row>
									</Col>

									<Col md={4}>
										<Row>
											<p>Sub-category</p>
											<Col sm={9}>
												<NormalSelect
													onChange={(e) => onChangeForm("unSubCat", e)}
													list={unSubCatList}
													text={"Select unavailability category"}
													defaultVal={
														unSubCat
															? { value: unSubCat }
															: unSubCat
													}
													isDisable={issueReadOnly}
												/>
											</Col>
										</Row>
									</Col>
								</Row>

								<Row>
									<Col sm={3}>Authorisation/ Level:</Col>
									<Col sm={9}>
										<NormalSelect
											onChange={(e) => onChangeForm("author", e)}
											list={authorList}
											text={"Select an authorisation or No select at all"}
											defaultVal={author ? { value: author } : null}
											isDisable={issueReadOnly}
										/>
									</Col>
								</Row>

								{issueDescShow && actionDescShow && (
									<div id={"action_desc"}>
										<Row className="normalInput">
											<Col sm={3}>Action Date:</Col>
											<Col sm={9}>
												<DatePicker
													placeholderText="Year/Month/Day Hour:Minute 12-hour clock format"
													selected={startActionDate && localTimeToPickerTime(startActionDate)}
													onChange={(date) => setStartActionDate(pickerTimeTolocalTime(date))}
													showTimeSelect
													timeFormat="p"
													timeIntervals={10}
													dateFormat="yyyy/MM/dd h:mm aa"
													maxDate={localTimeToPickerTime(todayToDate)}
													minDate={localTimeToPickerTime(startIssueDate)}
												/>
											</Col>
										</Row>

										<Row>
											<Col sm={3}>Action Description:</Col>
											<Col sm={9}>
												{actionDescList.length > 0 && (
													<NormalSelect
														onChange={onChangeActionDesc}
														list={actionDescList}
														text={"Select an action description or Input one"}
														defaultVal={
															gyActionDesc ? { label: gyActionDesc } : null
														}
													/>
												)}
											</Col>
										</Row>

										<Row className="normalInput">
											<Col sm={3} className="indentLTR">
												Internal Description:
											</Col>
											<Col sm={9}>
												<input
													type="text"
													value={gyActionDesc || ""}
													onChange={(e) =>
														onChangeForm("gyActionDesc", e.target.value)
													}
													ref={register}
													name="gyActionDesc"
													readOnly={!editGyActionDesc}
													style={
														!editGyActionDesc
															? { backgroundColor: "#E8E8E8" }
															: { backgroundColor: "#fff" }
													}
												/>
											</Col>
											{/* {!editGyActionDesc && (
												<Col sm={1}>
													<Icon onClick={(e) => setEditGyActionDesc(true)}>
														edit
													</Icon>
												</Col>
											)}
											{editGyActionDesc && (
												<Col sm={1}>
													<Icon onClick={(e) => setEditGyActionDesc(false)}>
														check
													</Icon>
												</Col>
											)} */}
										</Row>

										<Row className="normalInput">
											<Col sm={3} className="indentLTR">
												Client Description:
											</Col>
											<Col sm={9}>
												<input
													type="text"
													value={clActionDesc || ""}
													onChange={(e) =>
														onChangeForm("clActionDesc", e.target.value)
													}
													ref={register}
													name="clActionDesc"
													readOnly={!editClActionDesc}
													style={
														!editClActionDesc
															? { backgroundColor: "#E8E8E8" }
															: { backgroundColor: "#fff" }
													}
												/>
											</Col>
											{/* {!editClActionDesc && (
												<Col sm={1}>
													<Icon onClick={(e) => setEditClActionDesc(true)}>
														edit
													</Icon>
												</Col>
											)}
											{editClActionDesc && (
												<Col sm={1}>
													<Icon onClick={(e) => setEditClActionDesc(false)}>
														check
													</Icon>
												</Col>
											)} */}
										</Row>
									</div>
								)}

								<Row className="normalInput">
									<Col sm={3}>Comment for this issue:</Col>
									<Col sm={9}>
										<textarea
											ref={register}
											value={comment || ""}
											name="comment"
											onChange={(e) => onChangeForm("comment", e.target.value)}
											readOnly={issueReadOnly}
											style={
												issueReadOnly
													? { backgroundColor: "#E8E8E8" }
													: { backgroundColor: "#fff" }
											}
										/>
									</Col>
								</Row>

								<Row>
									<Col sm={3}>Resolved:</Col>
									<Col sm={1}>
										<input
											type="checkbox"
											ref={register}
											checked={
												resolved === null || resolved === undefined
													? false
													: resolved
											}
											name="resolved"
											onChange={(e) =>
												onChangeForm("resolved", e.target.checked)
											}
										/>
									</Col>
								</Row>
							</div>
						) : null}

						<Row className="issueFormButtons">
							<Col sm={3}></Col>
							<Col
								sm={3}
								className="panel-body"
								style={{ textAlign: "center" }}
							>
								<input
									type="submit"
									style={{ width: "60%" }}
									value="Save"
									className="btn btn-primary"
								/>
							</Col>

							<Col
								sm={3}
								className="panel-body"
								style={{ textAlign: "center" }}
							>
								<input
									type="button"
									className="btn btn-primary"
									onClick={() => props.closeForm()}
									style={{ width: "60%" }}
									value="Cancel"
								/>
							</Col>
							<Col sm={3}></Col>
						</Row>
					</form>
				</Container>
			)}

			{(loading || !loadForm) && (
				<Row style={{ marginTop: "15px", marginBottom: "15px" }}>
					<div className="overlay translucent" style={{ position: "fixed" }}>
						<Loader
							translucent={true}
							customStyle={{
								width: "150px",
								height: "150px",
								position: "fixed",
								left: "50%",
								top: "35%",
							}}
						/>
					</div>
				</Row>
			)}
		</>
	);
};